<div [ngClass]="isSingleLink ? 'clp-border-single-link' : 'clp-border'">
  <div class="clp-header flex-direction-row justify-content-between">
    <div class="flex-direction-row card-header d-flex justify-content-between align-items-center">
      <div class="card-preview">
        <span>{{ 'user_card.card_preview' | translate }}</span>
      </div>
    </div>
  </div>

  @if (!isSingleLink) {
    <div class="clp-container mt-10px">
      <br>
      <div class="background-container">
        <img class="img-background" [src]="backgroundImage" alt="">
      </div>
      <div class="information-container flex-direction-column gap-10px">
        <div class="photo-container">
          <div class="photo-frame">
            <img [src]="profilePicture" alt="Profile Photo" class="photo"/>
          </div>
          @if (companyLogo!==null){
            <div class="photo-frame small">
              <img [src]="companyLogo" alt="No Name" class="photo"/>
            </div>
          }
        </div>
        <div class="text-info-container"></div>
        <div class="text-name-surname mt-15px mb-7px">{{ fullName }}</div>
        <div class="text-role">
          <span class="text-role-span">{{ specialization }}</span>
          @if (specialization && company) {
            <span class="text-role-span-at">&nbsp; • &nbsp;</span>
          }
          <span class="text-role-span">{{ company }}</span>
        </div>
        <div class="text-location">{{ location }}</div>
        <div class="text-description">{{ description }}</div>
        <div class="hashtag-parent flex-direction-row">
          @for (hashtag of hashtagsList; track hashtag) {
            <div class="hashtag-div">{{ hashtag.name }}</div>
          }
        </div>
        <div class="clp-save-button w-100 mt-20px">
          <button class="filled-button short-button mobile-button butt-top button-responsive"><span class="butt-top-inside">{{ 'user_card.save_contact' | translate }}</span></button>
          @if (isContentContainsDocument) {
            <button class="filled-button short-button mobile-button butt-bottom button-responsive">
              <span class="butt-bottom-inside">{{ documentName }}</span>
            </button>
          }
        </div>
        <div class="social-icons mt-10px">
          @for (content of contentWithoutDocument; track content) {
            @if (content.active && !isContentViewGrid) {
              <div class="col-4 flex-direction-column justify-content-center">
                <img [src]="getContentIcon(content.contentIcon)" class="social-media-icon" alt="">
                <p class="text-center">{{ content.linkTitle ? (content.linkTitle.length > 10 ? content.linkTitle.slice(0, 10) + '...' : content.linkTitle) : content.contentName }}</p>
              </div>
            } @else if (content.active && isContentViewGrid) {
              <div class="user-card-content-highlight-container">
                <div class="user-card-content-highlight">
                  <img [src]="getContentIcon(content.contentIcon)" class="social-media-highlight-view-icon" alt="">
                  <p class="highlight-content-text">  {{ content.linkTitle ? (content.linkTitle.length > 20 ? content.linkTitle.slice(0, 20) + '...' : content.linkTitle) : content.contentName }}</p>
                </div>
              </div>
            }
          }
          <div class="button-bottom-last">
            <button class="text-button short-button mobile-button responsive-button mt-20px mb-20px">{{ 'user_card.create_my_own_profile' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  } @else {
    <div class="clp-container-single-content-link mt-10px">
      <div class="single-content-link">
        <div class="col-4 flex-direction-column justify-content-center">
          <img [src]="getContentIcon(showSingleContentLinkOrFirstContent()!.contentIcon)" class="social-media-icon single-content-link-icon" alt="">
          <br>
          <p class="text-center single-link-content-text">
            {{ showSingleContentLinkOrFirstContent()!.linkTitle ?
            (showSingleContentLinkOrFirstContent()!.linkTitle.length > 10 ?
            showSingleContentLinkOrFirstContent()!.linkTitle.slice(0, 10) + '...' : showSingleContentLinkOrFirstContent()!.linkTitle) :
            showSingleContentLinkOrFirstContent()!.contentName }}
          </p>
        </div>
      </div>
    </div>
  }
</div>
